module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_balloon-46ba0b3d5291e357e1364ec5482ee36f.png";